/** @jsx h */
import { Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Radiobox from './Radiobox';
import Checkbox from './Checkbox';
import { labels } from '../config';

const FilterFieldset = ({
  searchType,
  id,
  facet,
  triggerAjaxSubmit,
  pluginNamespace,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  function toggle() {
    setIsOpen(!isOpen);
  }

  function handleRadioChange() {
    setIsOpen(false);
    triggerAjaxSubmit();
  }

  function handleCheckboxChange() {
    triggerAjaxSubmit();
  }

  useEffect(() => {
    // if isOpen is true, prevent scoll on body element
    if (isOpen) {
      document.body.classList.add('nav-is-open');
    } else {
      document.body.classList.remove('nav-is-open');
    }
  }, [isOpen]);

  useEffect(() => {
    const hasActiveFilter = element => element.selected;
    const hasActiveFilters = facet.options.some(hasActiveFilter);
    setIsActive(hasActiveFilters);
  }, [facet, isOpen]);

  switch (searchType) {
    case 'global':
    case 'jobs':
    case 'press':
    case 'news':
    case 'article':
    case 'challenges':
      return (
        <li>
          <button
            className={`btn btn--tertiary search-section__fieldset-button ${
              isActive && 'search-section__fieldset-button--is-active'
            }`}
            id={`fieldset-${facet.type}-${id}`}
            aria-expanded={isOpen}
            aria-controls={`fieldset-panel-${facet.type}-${id}`}
            onClick={toggle}
            type="button"
          >
            <span>{facet.label}</span>
            <svg
              className="svg-chevron-down"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                fill="currentColor"
                d="M 7,8.167306 12.444903,2.722403 14,4.2775 l -7,7 -7,-7 1.5550972,-1.555097 z"
              />
            </svg>
          </button>
          <div
            className="search-section__fieldset-panel"
            id={`fieldset-panel-${facet.type}-${id}`}
            aria-hidden={!isOpen}
            aria-labelledby={`fieldset-${facet.type}-${id}`}
          >
            <div>
              <div className="search-section__fieldset-panel-header">
                <h2>{facet.label}</h2>
                <button
                  className="search-section__fieldset-close-button"
                  type="button"
                  onClick={toggle}
                >
                  <span className="sr-only">{labels.faceting.filterClose}</span>
                  <svg
                    className="svg-close"
                    aria-hidden="true"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g stroke="none" stroke-width="1" fill-rule="evenodd">
                      <polygon fill="none" points="0 0 24 0 24 24 0 24" />
                      <polygon
                        fill="currentColor"
                        fill-rule="nonzero"
                        transform="translate(11.939340, 12.060660) rotate(135.000000) translate(-11.939340, -12.060660) "
                        points="1.43933983 11.0606602 22.4393398 11.0606602 22.4393398 13.0606602 1.43933983 13.0606602"
                      />
                      <polygon
                        fill="currentColor"
                        fill-rule="nonzero"
                        transform="translate(12.060660, 12.060660) rotate(45.000000) translate(-12.060660, -12.060660) "
                        points="1.56066017 11.0606602 22.5606602 11.0606602 22.5606602 13.0606602 1.56066017 13.0606602"
                      />
                    </g>
                  </svg>
                </button>
              </div>

              <ul className="centers__list-inner">
                {facet.options.length
                  ? facet.options.map(option => (
                      <Radiobox
                        option={option}
                        filterName={facet.name}
                        handleChange={handleRadioChange}
                        pluginNamespace={pluginNamespace}
                        key={option.value}
                      />
                    ))
                  : ''}
              </ul>
            </div>
          </div>
        </li>
      );
    case 'courses':
      return (
        <>
          {facet.options.length
            ? facet.options.map(option => (
                <Checkbox
                  option={option}
                  filterName={facet.name}
                  handleChange={handleCheckboxChange}
                  pluginNamespace={pluginNamespace}
                  key={option.value}
                />
              ))
            : ''}
        </>
      );
    default:
      return labels.search.unavailable;
  }
};

export default FilterFieldset;
